<template>
<div class="corporateMember">
    <div>
        <div class="country bodyL">{{ member.country }}</div>
    </div>
    <div class="logo">
        <Image :image="member.logo" :width="160" imageClass="contain" />
    </div>
    <NuxtLink :to="member.link" :external="true" class="overlink" target="_blank" rel="noreferer noopener"></NuxtLink>
</div>
</template>

<script lang="ts" setup>
defineProps<{ member: any }>()
</script>

<style lang="scss" scoped>
.corporateMember {
    position: relative;

    padding-left: var(--size-gutter-default);
    border-left: var(--size-thickness) solid var(--color-primary);

    .country {
        font-weight: bold;
        color: var(--color-primary);
        margin-bottom: 4px;
    }

    .name {
        max-width: 250px;
        text-wrap: balance;
    }

    .logo {
        margin-top: var(--size-gutter-default);
        position: relative;
        height: 80px;
        width: 100%;
        max-width: 160px;

        &:deep(.responsivePicture) {
            background-image: none !important;

            img {
                object-position: top left;
            }
        }
    }
}


@media screen and (max-width: 600px) {
    .corporateMember {

        display: flex;
        padding-inline: 0;
        border-left: 0;
        border-bottom: var(--size-thickness) solid var(--color-primary);
        padding-block: var(--size-gutter-default);
        gap: var(--size-gutter-default);
        justify-content: space-between;

        .logo {
            margin-left: auto;
            display: flex;
            align-items: flex-start;
            gap: var(--size-gutter-default);

            &:deep(.responsivePicture) {
                background-image: none !important;

                img {
                    object-position: top right;
                }
            }
        }
    }


}
</style>